<template>

    <div class="container mt-4" v-if="ContactInfo">
        <h3>Profile</h3>
        <b-card bg-variant="light" >
            <b-form-group horizontal
                            breakpoint="lg"
                            label="Contact Details"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0">
                <b-form-group horizontal
                            label="First Name:"
                            label-class="text-sm-right"
                            label-for="shippingFullName">
                <b-form-input id="shippingFullName" v-model="ContactInfo.FirstName" readonly></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Last Name:"
                            label-class="text-sm-right"
                            label-for="nestedStreet">
                <b-form-input id="nestedStreet" v-model="ContactInfo.LastName" readonly></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Phone:"
                            label-class="text-sm-right"
                            label-for="nestedCity">
                <b-form-input id="nestedCity" v-model="ContactInfo.Phone"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Mobile:"
                            label-class="text-sm-right"
                            label-for="nestedState">
                <b-form-input id="nestedState" v-model="ContactInfo.Mobile"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            label="Email:"
                            label-class="text-sm-right"
                            label-for="nestedCountry">
                <b-form-input id="nestedCountry" v-model="ContactInfo.Email"></b-form-input>
                </b-form-group>
            </b-form-group>
            <b-btn variant="success" v-on:click="UpdateProfile">Save</b-btn>

        </b-card>
        <b-card bg-variant="light" >
            <b-form-group horizontal
                            breakpoint="lg"
                            label="Change Password"
                            label-size="lg"
                            label-class="font-weight-bold pt-0"
                            class="mb-0">
                <b-form-group horizontal
                            label="Old Password"
                            label-class="text-sm-right">
                <b-form-input type="password" v-model="OldPassword"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            :validated="NewPasswordsMatch"
                            label="New Password"
                            label-class="text-sm-right">
                <b-form-input type="password" v-model="NewPassword"></b-form-input>
                </b-form-group>
                <b-form-group horizontal
                            :validated="NewPasswordsMatch"
                            label="Re Enter New Password"
                            label-class="text-sm-right">
                <b-form-input type="password" v-model="NewPassword2"></b-form-input>
                </b-form-group>
            </b-form-group>
            <b-btn variant="success" :disabled="!NewPasswordsMatch" v-on:click="ChangePassword">Change Password</b-btn>
        </b-card>
        <b-card bg-variant="light" >
        <h3>Addresses</h3>
        
        
        <b-btn to="NewAddress">New Address</b-btn>
        <b-list-group>
            <b-list-group-item v-for="(item, index) in selectedCompanyAddresses" v-bind:key="index">
                <b-row>
                    <b-col>
                        {{item.AttentionTo}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.Line1}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.Line2}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.Line3}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.City}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.State}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.Postcode}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        {{item.Country}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-checkbox :checked="company.PrimaryShippingAddress && item.Oid == company.PrimaryShippingAddress.Oid" disabled>
                            Primary Shipping Address
                        </b-form-checkbox>
                        <!-- <b-form-checkbox :checked="item.IsPrimaryBilling" disabled>
                            Primary Billing Address
                        </b-form-checkbox> -->
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-btn variant="primary" v-on:click="editAddress(item.Oid)">Edit</b-btn>
                        <b-btn v-if="!company.PrimaryShippingAddress || item.Oid != company.PrimaryShippingAddress.Oid" :disabled="isProcessingPrimary" variant="primary" v-on:click="makePrimaryShipping(item.Oid)">Make Primary Shipping Address</b-btn>
                    </b-col>
                </b-row>
            </b-list-group-item>
        </b-list-group>
        </b-card>
    </div>
</template>

<script>
import store from "@/store.js";
import ProfileService from "../services/ProfileService";
import Swal from 'sweetalert2';
import _ from 'lodash';

function GetContactInfo(done) {
  ProfileService.GetProfile()
    .then(response => {
      if (response.data.length > 0) {
        done(null, response.data[0]);
      } else {
        done("unable to get profile");
      }
    })
    .catch(() => {
      done("unable to get profile");
    });
}

export default {
  name: "Profile",
  data() {
    return {
        ContactInfo: null,
        OldPassword: "",
        NewPassword: "",
        NewPassword2: "",
        isProcessingPrimary: false
    };
  },
  computed: {
    Items() {
      return store.state.cart;
    },
    NewPasswordsMatch() {
        if(this.NewPassword && this.NewPassword.length > 0) {
            return this.NewPassword === this.NewPassword2;
        }
        return false;
        //return this.NewPassword && this.NewPassword.length > 0 && this.NewPassword === this.NewPassword2;
    },
    company() {
        if(this.ContactInfo){
            const company = _.find(this.ContactInfo.Companies, i => i.Oid === this.$store.state.auth.company.Oid);
            return company
        }
    },
    selectedCompanyAddresses(){
        return this.company.Addresses;
    }
  },
  beforeRouteEnter(to, from, next) {
      if(store.state.auth.userInfo) {      
        GetContactInfo((err, profile) => {
            next(vm => vm.setData(err, profile));
        });
      }
      else {
          next({name: 'login'});
      }
  },
  beforeRouteUpdate(to, from, next) {
    this.ContactInfo = null;
    GetContactInfo((err, profile) => {
      this.setData(err, profile);
      next();
    });
  },
  methods: {
    setData(err, profile) {
      if (err) {
        this.error = err.toString();
      } else {
        this.ContactInfo = profile;
      }
    },
    editAddress(key) {
        this.$router.push({ name: 'EditAddress', params: { key: key } });
    },
    makePrimaryShipping(key) {
        this.isProcessingPrimary = true;
        ProfileService.SetPrimaryShipping(this.ContactInfo, this.company.Oid, key).then(response => {
            this.$toasted.success('Address updated').goAway(3000);
            this.ContactInfo = response.data.Record;
            this.isProcessingPrimary = false;
        });
    },
    UpdateProfile() {
        ProfileService.UpdateProfile(this.ContactInfo).then(response => {
            //this.$toasted.success('Profile saved').goAway(3000);
            this.ContactInfo = response.data.Record;

            Swal.fire({
                title: 'Profile Saved',
                icon: 'success',
                text: 'Your profile has been updated. Where would you like to go next?',
                showDenyButton: true,
                showCancelButton: true,
                confirmButtonText: 'Main Page',
                confirmButtonColor: '#02AC1E',
                denyButtonText: `Quick Order`,
                denyButtonColor: '#663399',
                cancelButtonText: `Stay Here`,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.$router.push({ path: "/" });
                } else if (result.isDenied) {
                    this.$router.push({ name: 'Quick' });
                }
            })
        });
    },
    ChangePassword() {
        if(this.NewPasswordsMatch) {
            ProfileService.ChangePassword(this.OldPassword, this.NewPassword).then(response => {
                if(response.data.Data.Matched) {
                    this.$store.commit("SetCredentials", { username: this.$store.state.auth.username, password: this.NewPassword, userInfo: this.$store.state.auth.userInfo } );
                    this.$toasted.success('Password changed').goAway(3000);
                    this.OldPassword = "";
                    this.NewPassword = "";
                    this.NewPassword2 = "";
                }
                else
                {
                    this.$toasted.error('Old Password Invalid').goAway(3000);
                }
            })
            .catch(function (error) {
                this.$toasted.error('Invalid Password').goAway(3000);
            });
        }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile.vue